import { useScreenSize } from '@shared/hooks/useScreenSize';
import { ReactElement, useState } from 'react';
import CloseConfirmDialog from '../CloseConfirmDialog';
import DeleteButton from './DeleteButton';
import { SettingsMenu } from './SettingsMenu';

export type SettingsMenuProps = {
  id: string;
  title?: string;
  children?: ReactElement;
  widgetId: string;
  onWidgetClose?: () => void;
  isHideDeleteButton?: boolean;
};

export default function Settings(props: SettingsMenuProps) {
  const { isMobile } = useScreenSize();
  const { widgetId, onWidgetClose } = props;
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return !isMobile ? (
    <SettingsMenu {...props} isCloseConfirmDialog={isDialogOpen} setIsCloseConfirmDialog={setIsDialogOpen} />
  ) : (
    <>
      <DeleteButton id={widgetId} variant="link" onWidgetClose={() => setIsDialogOpen(true)} />
      <CloseConfirmDialog open={isDialogOpen} setOpen={setIsDialogOpen} onClose={onWidgetClose} id={widgetId} />
    </>
  );
}
